export const API_EXTERNAL_ENDPOINT = 'villages/home'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/villages/home'
